// FILE: client/src/pages/secure/FormsPortalPage.js
// (This is a NEW file)

import React from 'react';
import { Link } from 'react-router-dom';
import SignatureApprovalsPanel from '../../components/secure/SignatureApprovalsPanel';

const FormsPortalPage = () => {
    // In the future, you can fetch a list of available forms from an API
    const forms = [
        {
            title: 'Independent Contractor Agreement',
            description: 'Create a new ICA for an agent associated with the brokerage.',
            link: '/dashboard/forms/independent-contractor-agreement',
            role: 'Sponsoring Broker' // Or whatever role can access this
        },
        {
            title: 'Exclusive Buyer Representation Agreement',
            description: 'Generate a new agreement for a client purchasing property.',
            link: '/dashboard/forms/buyer-agency',
            role: 'Agent'
        },
        {
            title: 'Exclusive Right to Sell Listing Agreement',
            description: 'Generate a new listing agreement for a seller client.',
            link: '/dashboard/forms/listing-agreement',
            role: 'Agent'
        },
        {
            title: 'Disclosure of No Agency',
            description: 'Provide a disclosure of no agency relationship to a consumer.',
            link: '/dashboard/forms/no-agency',
            role: 'Agent'
        }
    ];

    return (
        <div className="p-4 md:p-8">
            <h1 className="text-3xl font-bold text-slate-800 mb-6">Forms & Agreements Portal</h1>
            <SignatureApprovalsPanel />
            <p className="text-slate-600 mb-8">Select a document below to begin.</p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {forms.map(form => (
                    <Link key={form.title} to={form.link} className="block p-6 bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow">
                        <h2 className="text-xl font-bold text-indigo-700">{form.title}</h2>
                        <p className="text-slate-600 mt-2">{form.description}</p>
                        <div className="mt-4">
                            <span className="inline-block bg-slate-200 text-slate-800 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded-full">
                                For: {form.role}
                            </span>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
};

export default FormsPortalPage;
